import { useEffect, useState } from "react";

import { BREAKPOINT_LARGE, isServerSide } from "@jti/fe-common";

export const useViewport = (): { width: number } => {
  const [width, setWidth] = useState(!isServerSide() ? window.innerWidth : BREAKPOINT_LARGE);

  useEffect(() => {
    const handleWindowResize = () => setWidth(window.innerWidth);
    window.addEventListener("resize", handleWindowResize);

    return () => window.removeEventListener("resize", handleWindowResize);
  }, []);
  return { width };
};
